import { createStore } from 'vuex'
import contractors from '@/store/contractors'
import global from '@/store/global'

export default createStore({
  modules: {
    global,
    contractors
  }
})
